// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jl-0";
export var fileList = "_jl-2";
export var removeFileButton = "_jl-1";